<template>
  <div class="form-group no-margin row" style="margin-bottom:10px;">
      <label class="col-form-label">{{ label }}</label>
    <div class="col-auto">
      <select class="custom-select custom-select-sm" @change="changeLimit()" v-model="data.params.limit" name="limitCount">
        <option v-for="(option, index) in data.limitOption" :value="option.value" :key="index">
          {{ option.text }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import {reactive, ref, computed, watch, onMounted, onUnmounted} from '@vue/composition-api'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment';

export default {
  props: {
    data: {
      limitOption : "",
    },
    label: "",
  },
  components: {Datepicker},
  setup(props, context) {
    const data = props.data;

    data.limitOption =  [{value:'10',text:'10'},{value:'25',text:'25'},{value:'50',text:'50'},{value:'100',text:'100'}]

    return {
      ...actions(props.data, context)
    }
  }
}

function actions(data, context) {
  function changeLimit(){
    data.params.page = 1; //검색 후 1페이지로 이동
    context.emit('search', data.params)
  }
  function search() {
    data.params.page = 1; //검색 후 1페이지로 이동
    context.emit('search', data.params)
  }

  function reset() {
    data.params.schText = '';
   // context.emit('reset')
  }

  return {search, reset, changeLimit}
}

</script>
